import { gql } from "@apollo/client";

export const JOB_PREFERENCES_FRAGMENT = gql`
  fragment JobPreferencesFragment on JobPreference {
    id
    jobSearchStatus
    jobCategories
    minimumCompensation
    jobLocations
    openToSeasonal
    openToInternational
    optedInToJobSeekerEmails
  }
`;

export const JOB_PREFERENCE_DATA = gql`
  query JobPreferenceFieldsQuery {
    jobPreferenceFields {
      jobSearchStatus {
        label
        value
      }
      locations {
        label
        value
      }
      jobCategories {
        label
        value
      }
      minimumCompensation {
        label
        value
      }
    }

    me {
      id
      jobPreference {
        ...JobPreferencesFragment
      }
    }
  }
  ${JOB_PREFERENCES_FRAGMENT}
`;
